const api = {
    location: '/location/',
    locationDownload: '/location/export',
    getLocationList: '/location/list',
    getMajorLocations: '/location/major-list',
    middleLocation: '/middle-location/',
    deleteMiddleLocation: '/middle-location',
    deleteMinorLocation: '/minor-location',
    minorLocation: '/minor-location/',
    getMiddleLocations: '/middle-location/major_id/middle-list',
    updateMajorLocation: '/location/company_code/item_id',
    updateMiddleLocation: '/middle-location/company_code/major_id/item_id',
    updateMinorLocation: '/minor-location/company_code/major_id/middle_id/item_id',
    getMinorLocations: '/minor-location/major_id/middle_id/minor-list',
    company: '/company/',
    getCompanies: '/company/list',
    deleteCompany: '/company/list',
    updateCompany: '/company/item_id',
    companyDownload: '/company/export',

    // options
    companyOptions: '/company/options',
    majorLocationOptions: '/location/major-list',
    middleLocationOptions: '/middle-location/major_location_id/middle-list',
    minorLocationOptions: '/minor-location/major_location_id/middle_location_id/minor-list',
    majorContentOptions: '/content/major-list',
    middleContentOptions: '/middle-content/major_content_id/middle-list',
    minorContentOptions: '/minor-content/major_content_id/middle_content_id/minor-list',

    // details
    containerDetails: '/container/item_id',

    container: '/container/',
    containerDownload: '/container/export',
    getListContainer: '/container/list',
    deleteContainer: '/container/bulk-delete',
    updateContainer: '/container/item_id',
    getContainerTypeList: '/container-category/list',
    createQRCodeContainer: '/container/qrcode',
    getContainerTypeOptionList: '/container-category/options',

    postContractCode: '/contract/management-code',

    getInstallationList: '/installation-task/list',
    intallationTask: '/installation-task/',
    intallationTaskId: '/installation-task/task_id',

    // Invetory
    getInventoryList: '/inventory/list',
    inventoryManagementDownload: '/inventory/export',

    // Receiving
    getListReceiving: '/import-task/list',
    getReceivingDetail: '/import-task/task_id',

    // User
    getUserOptions: '/user/options',
    userDownload: 'user/export',

    // Processing task
    processingTask: '/processing-task',
    processingList: '/processing-task/list',

    // REVERT
    revertUser: '/user/item_id',
    revertCompany: '/company/item_id',
    revertContainer: '/container/item_id',
    revertContainerCategory: '/container-category/item_id',
    revertMajorContent: '/content/item_id',
    revertMiddleContent: '/middle-content/major_id/item_id',
    revertMinorContent: '/minor-content/major_id/middle_id/item_id',
    revertMajorLocation: '/location/company_code/item_id',
    revertMiddleLocation: '/middle-location/company_code/major_id/item_id',
    revertMinorLocation: '/minor-location/company_code/major_id/middle_id/item_id',

    // CONTRACT
    contract: '/contract',
    contractList: '/contract/list',
    contractBulkDelete: '/contract/bulk-delete',
    threshold: '/threshold',
    thresholdAlert: '/threshold-alert',

    dashboardMaster: '/dashboard/master',
    dashboardArea: '/dashboard/area',
    dashboardRanking: '/dashboard/ranking',
    dashboardAlert: '/dashboard/alert',
    dashboardStatus: '/dashboard/status',
    dashboardTrend: '/dashboard/trend',
    dashboardReceiving: '/dashboard/receiving',


    // TASK HISTORY
    taskHistory: '/task-history',
    taskHistoryList: '/task-history/list',
    taskHistoryDownload: '/task-history/export',

    // MASTER HISTORY
    masterHistoryList: '/edit-history/list',
    masterHistoryDownload: '/edit-history/export',

    // TASK CATEGORY
    processingWordDownload: '/task-category/export',

    // CONTENT
    contentDownload: '/task-content/export',

    // CONTAINER CATEGORY
    containerCategoryDownload: 'container-category/export',

    // TRACE MANAGEMENT
    traceManagementDownload: 'trace-management/export',
    traceList: '/tracking/list',
    tracking: '/tracking',
    trackingExport: '/tracking/export',

    // INVENTORY PROGRESS
    inventoryProgressList: 'inventory-mng/list',
    inventoryProgressExport: 'inventory-mng/export',
    inventoryProgress: 'inventory-mng/',
    inventoryProgressDetailList: 'inventory-container/inventory_id/list',
    inventoryProgressDetail: 'inventory-container/inventory_id',

    // INVENTORY PERFORMANCE
    inventoryPerformanceList: 'inventory-mng/list',
    inventoryPerformanceExport: 'inventory-mng/export',

    // UNIT INTEGRATION
    unitIntegrationTaskList: '/integration-task/list',
    unitIntegrationTaskDetail: '/integration-task/task_id',
    unitIntegrationManagementUnits: '/integration-task/task_id/management-units',

    uploadS3: '/upload-s3',
    checkPresignedUrl: '/upload-s3/generate-presigned-url',

    // CR #28 - External API admin
    externalApiKey: '/external-api-key',
    externalIpWhitelist: '/external-ip-whitelist',
};

export default api;
